<div style="display: inline-block; vertical-align: middle;" class="form-group"  [ngClass]="{'has-error': dateControl.invalid}">
  <label *ngIf="withLabel" class="control-label">{{placeholder}}</label>
  <div style="width:min-content;display: table;" class="input-group mt-2">
    <input (focusin)="selectText($event)" (keydown.enter)="hidePicker($event)"
      style="min-width: 115px; width:115px !important" class="form-control" autocomplete="off" #ndt
      [placeholder]="placeholder" [value]="dt | date:'dd/MM/yyyy'">
    <span [style.display]="withJewishDate ? 'table-cell' : 'none'" style="min-width: 115px; width:min-content"
      class="input-group-addon" id="jewishDate"> </span>
  </div>
</div>